import { AvatarMetaCardProps } from "./types";

import "./styles.css";

const AvatarMetaCard = ({
  avatar,
  title,
  description,
  className,
  style,
}: AvatarMetaCardProps) => {
  return (
    <div
      className={`avatar-meta-card flex items-start gap-200 ${className ?? ""}`}
      style={style}
    >
      {avatar && <div className="avatar-meta-card-avatar">{avatar}</div>}

      <div className="avatar-meta-card-detail flex flex-col gap-100">
        {title != null && (
          <div className="avatar-meta-card-title body-m-regular">{title}</div>
        )}

        {description != null && (
          <div className="avatar-meta-card-description body-s-regular">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarMetaCard;
